import { type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import useSWR from 'swr'
import LocalStorage from '@forwardflow/services/LocalStorage'
import { UserService } from '@forwardflow/services/UserService'
import { PageLoader } from '@forwardflow/ui'
import Maintenance from '@forwardflow/pages/Maintenance'
import { canAccessDuringMaintenance, isMaintenancePublicPath } from './maintenancePolicy'

export default function MaintenanceGate({ children }: { children: ReactNode }) {
   const { pathname } = useLocation()
   const token = LocalStorage.get('access_token')
   const publicPath = isMaintenancePublicPath(pathname)
   // Authenticate from the API, never from a stored profile or an email query parameter.
   // Key by session so a previous operator response cannot admit another user.
   const { data: user, error, isLoading } = useSWR(
      !publicPath && token ? ['maintenance-user', token] : null,
      UserService.getUserData,
      { shouldRetryOnError: false, revalidateOnFocus: true }
   )

   if (publicPath) return <>{children}</>
   if (token && isLoading) return <PageLoader />
   if (!error && token && canAccessDuringMaintenance(user?.email)) return <>{children}</>
   return <Maintenance />
}
